export default __webpack_public_path__ + "static/media/img4.f9aa30c7.png";